module.exports = __webpack_public_path__ + "img/Hospital.7f91c326.svg";